@if (showSpinner) {
  <app-loader> </app-loader>
}
<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  <div class="container-fluid mb-4">
    <div class="attendance-time-section">
      <div class="row">
        <div class="col-sm-6 col-md-4 col-xl-2 timer">
          <div class="timer-inner my-2" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <h1>Working Hours</h1>
            <h1>{{ workingHours }} hrs</h1>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 col-xl-2 timer">
          <div class="timer-inner my-2" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <h1>Worked Hours</h1>
            <h1>{{ stats[0].worked_time | number : '1.2-2' }} hrs</h1>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 col-xl-2 timer">
          <div class="timer-inner my-2" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <h1>Over Time</h1>
            <h1>{{ overtime === null ? "0" : overtime }} hrs</h1>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 col-xl-2 timer">
          <div class="timer-inner my-2" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <h1>Check In Missing</h1>
            <h1> {{ stats[0].check_in_missed }}</h1>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 col-xl-2 timer">
          <div class="timer-inner my-2" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <h1>Late Check In</h1>
            <h1>{{ stats[0].check_in_late }} hrs</h1>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 col-xl-2 timer">
          <div class="timer-inner my-2" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <h1>Short Hours</h1>
            <h1>{{ stats[0].total_short_time | number : '1.2-2' }} hrs</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="attendance-report">
      <div class="row mt-2">
        <div class="col-lg-5 col-xl-4 my-2">
          <div class="report-inner-section px-2 px-sm-4 py-3" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <div class="report-inner-left-heading">
              <h1>Today Report</h1>
            </div>
            <div class="report-inner-left-timer py-2">
              <div class="left-timer">
                <p>{{ checkInTime }}</p>
                <p>{{checkInTime === "" ? " CHECK IN MISSING" : " CHECK IN"}}</p>
              </div>
              <div class="right-timer" [ngClass]="{ 'dark-text': selectedMode === 'dark' }">
                <p>{{this.att_total_hours}} <span>Hrs</span></p>
                <p>Shift Time</p>
              </div>
            </div>
            <div class="report-inner-left-progress px-2 py-2">
              <div class="progress-timer">
                <p>Timer</p>
                <p>{{shiftRemainingTime}}</p>
              </div>
              <div class="report-inner-left-progress-bar">
                <progress id="file" value="{{percentageInProgress}}" max="100"></progress>
              </div>
            </div>
            <div class="report-inner-left-btn pt-3 pb-2">
              <button (click)="getCheckInDetail()" [disabled]="isSecondShiftEmployee()">Check In</button>
              <button (click)="getCheckOutDetail()" [disabled]="isSecondShiftEmployee()">Check Out</button>
            </div>
          </div>
        </div>
        <div class="col-lg-7 col-xl-8 my-2">
          <div class="attendance-report-section px-2 px-sm-4 py-3"
            [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <div class="col-12 px-0">
              <div class="graph-header pb-3">
                <h1>Attendance Report</h1>
              </div>
              <div class="graph-btn">
                <button (click)="showCheckInData()">Check In</button>
                <button (click)="showCheckOutData()">Check Out</button>
              </div>
              <div class="" style="height:160px">
                <canvas id="chLine"></canvas>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="attendance-filter-section my-2">
      <form #f="ngForm" (ngSubmit)="onSubmit(f)">
        <div class="form-row">
          <div class="col-md-10">
            <div class="row">
              <div class="col-sm-4 col-md-4 my-2 attendance-filter-field"
                [ngClass]="{ 'dark-input': selectedMode === 'dark' }">
                <input type="text" placeholder="Start Date" onfocus="(this.type='date')" name="startdate" id="startdate"
                  class="date-type form-control" id="datetimepicker4" ngModel #startdate="ngModel" />
                </div>
                <div class="col-sm-4 col-md-4 my-2 attendance-filter-field"
                  [ngClass]="{ 'dark-input': selectedMode === 'dark' }">
                  <input type="text" placeholder="End Date" onfocus="(this.type='date')" name="enddate" id="enddate"
                    class="date-type form-control" ngModel #enddate="ngModel" />
                  </div>
                  <div class="col-sm-4 col-md-4 my-2 attendance-filter-field"
                    [ngClass]="{ 'dark-input': selectedMode === 'dark' }">
                    <select id="attendancetype" name="attendancetype" class="checks-dropdown form-control selectpicker"
                      ngModel #attendancetype="ngModel">
                      <option selected="true" disabled="disabled">Select Type</option>
                      <option value="LastMonth">Last Month</option>
                      <option value="ThisMonth">Current Month</option>
                    </select>
                    <i class="fa fa-chevron-down"></i>
                  </div>
                </div>

              </div>
              <div class="col-md-2">
                <div class="col-12 my-2 attendance-filter-field">
                  <button type="submit" class="form-control">Apply</button>
                </div>
              </div>

            </div>
          </form>
        </div>
        <div class="attendance-report-table">
          <div class="attendance-report-table-header d-flex justify-content-around px-3">
            <div class="table-heading">Date</div>
            <div class="table-heading text-center">Check In</div>
            <div class="table-heading text-center">Check Out</div>
            <div class="table-heading text-center">Working Hours</div>
            <div class="table-heading text-center">Status</div>
            <div class="table-heading text-center">Action</div>

          </div>
          @for (type of typeArr; track type) {
            <attendance-type [type]="type" [paidLeaves]="paidLeaves"
            [unpaidLeaves]="unpaidLeaves"> </attendance-type>
          }
        </div>
      </div>
    </main>